import type { TranslateDictionary } from './en.js';

export const Nl: TranslateDictionary = {
  'Start airplay': 'Start AirPlay',
  'Stop airplay': 'Stop AirPlay',
  Audio: 'Audio',
  Captions: 'Ondertitels',
  'Enable captions': 'Ondertitels inschakelen',
  'Disable captions': 'Ondertitels uitschakelen',
  'Start casting': 'Start casting',
  'Stop casting': 'Stop casting',
  'Enter fullscreen mode': 'Naar volledig scherm',
  'Exit fullscreen mode': 'Volledig scherm afsluiten',
  Mute: 'Dempen',
  Unmute: 'Dempen opheffen',
  'Enter picture in picture mode': 'Activeer beeld-in-beeld-modus',
  'Exit picture in picture mode': 'Sluit beeld-in-beeld-modus',
  Play: 'Afspelen',
  Pause: 'Pauze',
  'Playback rate': 'Afspeelsnelheid',
  'Playback rate {playbackRate}': 'Afspeelsnelheid {playbackRate}',
  Quality: 'Kwaliteit',
  'Seek backward': 'Terug',
  'Seek forward': 'Vooruit',
  Settings: 'Instellingen',
  Auto: 'Auto',
  'audio player': 'audiospeler',
  'video player': 'videospeler',
  volume: 'Volume',
  seek: 'Zoeken',
  'closed captions': 'Ondertitels',
  'current playback rate': 'huidige afspeelsnelheid',
  'playback time': 'afspeeltijd',
  'media loading': 'media laden',
  settings: 'Instellingen',
  'audio tracks': 'audiotracks',
  quality: 'Kwaliteit',
  play: 'afspelen',
  pause: 'pauze',
  mute: 'dempen',
  unmute: 'dempen opheffen',
  'chapter: {chapterName}': 'hoofdstuk: {chapterName}',
  live: 'live',
  Off: 'Uit',
  'start airplay': 'start AirPlay',
  'stop airplay': 'stop AirPlay',
  'start casting': 'start casting',
  'stop casting': 'stop casting',
  'enter fullscreen mode': 'naar volledig scherm',
  'exit fullscreen mode': 'volledig scherm afsluiten',
  'enter picture in picture mode': 'activeer beeld-in-beeld-modus',
  'exit picture in picture mode': 'sluit beeld-in-beeld-modus',
  'seek to live': 'ga naar live',
  'playing live': 'live afspelen',
  'seek back {seekOffset} seconds': '{seekOffset} sec. terug',
  'seek forward {seekOffset} seconds': '{seekOffset} sec. vooruit',
  'Network Error': 'Netwerkfout',
  'Decode Error': 'Decodeerfout',
  'Source Not Supported': 'Bron niet ondersteund',
  'Encryption Error': 'Versleutelingsfout',
  'A network error caused the media download to fail.':
    'Een netwerkfout heeft ervoor gezorgd dat het downloaden van de media is mislukt.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Een mediafout heeft ervoor gezorgd dat het afspelen is afgebroken. De media kan beschadigd zijn of uw browser ondersteunt dit formaat niet.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Er is een niet-ondersteunde fout opgetreden. De server of het netwerk is mislukt, of uw browser ondersteunt dit formaat niet.',
  'The media is encrypted and there are no keys to decrypt it.':
    'De media is versleuteld en er zijn geen sleutels om het te ontsleutelen.',
};
